import { Component } from 'react';
import { Contribution } from '../../../../../../../common/model/input/contributions/types';
import { ModelEntityType } from '../../../../../../../common/model/input/types';
import { ModelEntitySearchResponseItem } from '../../../../../../../common/model/search/types';
import { ModalOptions } from '../../../../../../untidy/redux/modules/modal';
import { aiName } from '../../../../../../untidy/texts';
import { TextField } from '../../../../../generic/components/inputs/text-field';
import { themeDEPRECATED } from '../../../../../generic/global/styles';
import Search from '../../../output/search';
import {
  ContributionModalParagraph,
  ContributionModalTitle,
  FormRow,
  FullRow,
  getContributeSearchStyle,
  Label,
  ProductCodeWithLabel,
  ProductRow,
  RemoveLink,
} from './common';
import { FormButton } from './form-button';

interface State {
  comment?: string;
  products?: ProductCodeWithLabel[];
}

interface Props {
  isSubmitting: boolean;
  submitContribution: (options: { target?: string; data: Contribution }) => void;
  options: ModalOptions;
}

export class MissingCompanyProductsForm extends Component<Props, State> {
  public state: State = {};

  public render() {
    const {
      isSubmitting,
      options: { target, targetName, existingData },
    } = this.props;
    const { products, comment } = this.state;
    const existingProducts = existingData && existingData.products;

    if (!target || !targetName || !existingProducts) {
      console.error('Missing required metadata for company');
      return null;
    }

    const canSubmit = products && products.length > 0;

    return (
      <>
        <ContributionModalTitle>What products are we missing for {targetName}?</ContributionModalTitle>
        <ContributionModalParagraph>
          A company's profile should include all the products and services the company produces and sells.
        </ContributionModalParagraph>
        <form
          onSubmit={e => {
            e.preventDefault();
          }}
        >
          <ContributionModalParagraph>
            The following products are already listed for {targetName}:
          </ContributionModalParagraph>
          <ul>
            {existingProducts
              .sort((a, b) => a.label.localeCompare(b.label))
              .map(d => (
                <li key={d.productCode}>{d.label}</li>
              ))}
          </ul>
          <FormRow>
            <FullRow>
              <Label>Which products should be added to this company?</Label>
              {products &&
                products.map(productDatum => (
                  <ProductRow key={productDatum.productCode}>
                    {productDatum.label}{' '}
                    <RemoveLink
                      onClick={() => {
                        this.setState(state => ({
                          products:
                            state.products && state.products.filter(p => p.productCode !== productDatum.productCode),
                        }));
                      }}
                    >
                      (remove)
                    </RemoveLink>
                  </ProductRow>
                ))}
              <Search
                creatable="Suggest a new product:"
                onChange={(option?: ModelEntitySearchResponseItem) => {
                  if (!option) {
                    return;
                  }
                  this.setState(state => {
                    return {
                      products: (state.products || []).concat({
                        productCode: option.id,
                        userCreated: option.created,
                        label: option.name,
                      }),
                    };
                  });
                }}
                searchTypes={[ModelEntityType.PRODUCT, ModelEntityType.MIXIN]}
                styleOverride={getContributeSearchStyle()}
              />
            </FullRow>
          </FormRow>
          <FormRow>
            <TextField
              label="Anything else you want to share?"
              id="comment"
              type="textarea"
              value={comment}
              disabled={isSubmitting}
              metaLabel="Optional"
              onChange={value => {
                this.setState({ comment: value });
              }}
            />
          </FormRow>
          <ContributionModalParagraph style={{ marginTop: themeDEPRECATED.rhythm(5) }}>
            Please note that contributions will not automatically affect the data in the model, but will be processed
            and evaluated either by {aiName} or the Upright team.
          </ContributionModalParagraph>
          <FormRow>
            <FormButton
              type="submit"
              disabled={isSubmitting || !canSubmit}
              onClick={() => {
                if (this.state.products && this.state.products.length > 0) {
                  this.props.submitContribution({
                    data: {
                      type: 'COMPANY_MISSING_PRODUCTS',
                      comment: this.state.comment,
                      products: this.state.products.filter(p => !p.userCreated).map(p => p.productCode),
                      newProducts: this.state.products.filter(p => p.userCreated).map(p => p.label),
                    },
                    target,
                  });
                }
              }}
              style={{ width: '100%' }}
            >
              Submit
            </FormButton>
          </FormRow>
        </form>
      </>
    );
  }
}
